/* eslint-disable max-len */
export default {
    header: {
        title: 'Fill out this simple form',
        subtitle: 'Our team will contact you promptly to discuss next steps.',
        main: 'Select service you are interested in'
    },
    list: {
        improve_title: 'Improve security and/or GDPR compliance of your application',
        decrease_title: 'Decrease the risk of cyber attack in your organization (Data Governance)'
    },
    improve: [{
        title: 'I want to have security of my applications checked for:',
        slug: 'improve-one',
        number: '1/4',
        option: [{
            text: 'Web',
            slug: 'web',
            icon: 'improve11'
        }, {
            text: 'Mobile',
            slug: 'mobile',
            icon: 'improve12'
        }, {
            text: 'Server',
            slug: 'server',
            icon: 'improve13'
        }]
    }, {
        title: 'I want you to check security of:',
        slug: 'improve-two',
        number: '2/4',
        option: [{
            text: 'running application',
            slug: 'running',
            icon: 'improve21'
        }, {
            text: 'application source code',
            slug: 'application',
            icon: 'improve22'
        }, {
            text: 'production server configuration',
            slug: 'production',
            icon: 'improve23'
        }]
    }, {
        title: 'I want to be sure that application is compliant with GDPR from:',
        slug: 'improve-three',
        number: '3/4',
        option: [{
            text: 'legal perspective (personal data identification, terms of service)',
            slug: 'legal',
            icon: 'improve31'
        }, {
            text: 'system architecture perspective (addressing GDPR provisions)',
            slug: 'system',
            icon: 'improve32en'
        }, {
            text: 'cybersecurity perspective (security of personal information)',
            slug: 'cybersecurity',
            icon: 'improve33'
        }]
    }, {
        title: 'After verification I need you to:',
        slug: 'improve-four',
        number: '4/4',
        option: [{
            text: 'support me in correction phase',
            slug: 'support',
            icon: 'common1'
        }, {
            text: 're-check it after applying corrections',
            slug: 're-check',
            icon: 'common2'
        }, {
            text: 'constantly monitor running application and their source code',
            slug: 'monitor',
            icon: 'improve43'
        }]
    }],
    decrease: [{
        title: 'Digital assets in my organization require:',
        slug: 'decrease-one',
        number: '1/3',
        option: [{
            text: 'recording',
            slug: 'recording',
            icon: 'decrease11'
        }, {
            text: 'risk calculation',
            slug: 'calculation',
            icon: 'decrease12'
        }, {
            text: 'risk management/security policies',
            slug: 'management',
            icon: 'decrease13'
        }]
    }, {
        title: 'To protect:',
        slug: 'decrease-two',
        number: '2/3',
        option: [{
            text: 'personal information',
            slug: 'personal',
            icon: 'decrease21'
        }, {
            text: 'know-how, recipes and trade secrets',
            slug: 'know-how',
            icon: 'decrease22'
        }, {
            text: 'payroll and wages',
            slug: 'payroll',
            icon: 'decrease23'
        }]
    }, {
        title: 'After verification I need you to:',
        slug: 'decrease-three',
        number: '3/3',
        option: [{
            text: 'support me in correction phase',
            slug: 'correction',
            icon: 'common1'
        }, {
            text: 're-check it after applying corrections',
            slug: 'applying',
            icon: 'common2'
        }, {
            text: 'prepare verification report',
            slug: 'verification',
            icon: 'decrease33'
        }]
    }],
    form: {
        name: 'First name and last name',
        mail: 'Mail',
        phone: 'Phone',
        message: 'Message',
        send: 'Send',
        refresh: 'Refresh'
    }
};



// WEBPACK FOOTER //
// ./src/i18n/en/estimation.js